import React from 'react';

import { useSelector } from 'react-redux';

import InfoIcon from '@atlaskit/icon/glyph/info';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import Tooltip from '@atlaskit/tooltip';

import { ScreenReadersOnly } from 'src/components/accessibility';
import { DiffType } from 'src/components/types/src/pull-request';
import { useIntl } from 'src/hooks/intl';
import { getCurrentPullRequestDiffType } from 'src/redux/pull-request/selectors';

import messages from './diff-file-status.i18n';

const PreviewMergeDiffIcon = () => {
  const intl = useIntl();
  const tooltipMessage = messages.previewMergeDiffMode;
  const intlMessage = intl.formatMessage(tooltipMessage);
  const prDiffType = useSelector(getCurrentPullRequestDiffType);

  if (prDiffType === DiffType.PREVIEW_MERGE_DIFF) {
    return (
      // Use <span> instead of <> Fragment to preserve element size for <Tooltip>
      <Tooltip position="right" content={intlMessage}>
        <span>
          <ScreenReadersOnly>{intlMessage}</ScreenReadersOnly>
          <InfoIcon
            primaryColor={token('color.icon', colors.DN100)}
            label={intl.formatMessage(tooltipMessage)}
          />
        </span>
      </Tooltip>
    );
  }
  return null;
};

export default PreviewMergeDiffIcon;
